import * as React from 'react';
import PropTypes from 'prop-types';

import { Icon, Popover } from 'antd';

import s from './style/RoleItem.pcss';
import RoleSelector from './RoleSelector';
import Loader from '../../../../shared/components/Loader/Loader';


export default class RoleItem extends React.Component {
  static propTypes = {
    item: PropTypes.shape().isRequired,
    selected: PropTypes.bool.isRequired,
    saving: PropTypes.bool.isRequired,
    onRemoveRole: PropTypes.func.isRequired,
    onEditRole: PropTypes.func.isRequired,
    onRoleSelect: PropTypes.func.isRequired,
  };

  state = {
    popoverVisible: false,
    editMode: false,
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.onHandleBlur);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.onHandleBlur);
  }

  setRef = (ref) => {
    this.btnContainer = ref;
  };

  onHandleBlur = (e) => {
    if (this.btnContainer && !this.btnContainer.contains(e.target)) {
      this.setEditMode(false);
    }
  };

  setPopoverVisible = popoverVisible => this.setState({ popoverVisible });
  setEditMode = (editMode) => {
    const newState = { editMode };
    if (editMode) {
      newState.popoverVisible = false;
    }
    this.setState(newState);
  };
  onRoleRemove = () => {
    const body = {
      id: this.props.item.id,
      status: 'role_status_delete',
    };
    this.props.onRemoveRole(body);
  };
  onRoleSelect = () => this.props.onRoleSelect(this.props.item.id);

  onEditRole = (name) => {
    const body = {
      id: this.props.item.id,
      name,
      status: 'role_status_rename',
    };
    return this.props.onEditRole(body).then(() => {
      this.setState({ editMode: false });
    });
  };

  renderPopoverContent = () => {
    const { saving } = this.props;
    if (saving) {
      return (
        <div className={s.popoverContent}>
          <div className={s.popoverItem} onClick={this.onRoleEdit}>
            <Loader fullScreen={false} size={20} />
          </div>
        </div>
      );
    }
    return (
      <div className={s.popoverContent}>
        <div className={s.popoverItem} onClick={() => this.setEditMode(true)}>
          Редактировать
        </div>
        <div className={s.popoverItem} onClick={this.onRoleRemove}>
          Удалить
        </div>
      </div>
    );
  }

  prevent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    const { popoverVisible, editMode } = this.state;
    const { item, selected } = this.props;
    return (
      <div
        ref={this.setRef}
        className={`${s.item} ${selected ? s.selected : ''}`}
        onClick={this.onRoleSelect}
      >
        <div className={s.name}>{item.name}</div>
        {item.isLocked &&
          <div className={s.lockedIcon} />
        }
        {!item.isLocked &&
          <div
            className={`${s.popoverContainer} ${popoverVisible ? s.shown : ''}`}
            onClick={this.prevent}
          >
            <Popover
              getPopupContainer={triggerNode => triggerNode}
              placement="bottomRight"
              trigger="click"
              onVisibleChange={this.setPopoverVisible}
              visible={popoverVisible}
              title={null}
              arrowPointAtCenter
              content={this.renderPopoverContent()}
            >
              <Icon type="ellipsis" />
            </Popover>
          </div>
        }
        {editMode && <RoleSelector onEditRole={this.onEditRole} role={item} />}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root/pages/Roles/Sidebar/RoleItem.js